"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("antd/dist/antd.css");

require("./TabsComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TabsComponent = function TabsComponent(_ref) {
  var tabPanes = _ref.tabPanes,
      defaultActiveKey = _ref.defaultActiveKey,
      onClickHandler = _ref.onClickHandler,
      className = _ref.className,
      activeKey = _ref.activeKey;
  var TabPane = _antd.Tabs.TabPane;
  var obj = {
    defaultActiveKey: defaultActiveKey || "0",
    onTabClick: onClickHandler,
    className: className || ""
  };
  if (activeKey) obj["activeKey"] = activeKey;
  return tabPanes ? /*#__PURE__*/_react["default"].createElement(_antd.Tabs, obj, tabPanes.map(function (item, index) {
    return /*#__PURE__*/_react["default"].createElement(TabPane, {
      tab: item === null || item === void 0 ? void 0 : item.tab,
      key: index,
      disabled: item === null || item === void 0 ? void 0 : item.disabled
    }, item === null || item === void 0 ? void 0 : item.component);
  })) : null;
};

var _default = TabsComponent;
exports["default"] = _default;